import { Button } from "@chakra-ui/react";
import type { ButtonProps } from "@chakra-ui/react";
import type { ReactNode } from "react";

import theme from "theme";

interface NeumorphicButtonProps extends ButtonProps {
  onClick?: () => void;
  variant?: string;
  children?: ReactNode;
  testId?: string;
}

const NeumorphicButton = ({
  onClick,
  variant,
  children,
  testId,
  ...rest
}: NeumorphicButtonProps) => {
  return (
    <Button
      onClick={onClick}
      variant={variant}
      fontSize={theme.fontSizes.btn}
      boxShadow="4px 4px 5px var(--chakra-colors-brand-500_6), -4px -4px 5px var(--chakra-colors-brand-500_3)"
      data-cy={testId}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default NeumorphicButton;
